module.exports = __webpack_public_path__ + "img/Admin.952e22a2.png";